import { RouteView } from '@/components/layouts'

const home = () => import(/* webpackChunkName: "storeHome" */ '@/views/my-store/home')
const setting = () => import(/* webpackChunkName: "setting" */ '@/views/my-store/setting')
const order = () => import(/* webpackChunkName: "order" */ '@/views/my-store/order')
const warehouse = () => import(/* webpackChunkName: "warehouse" */ '@/views/my-store/warehouse')
const quotation = () => import(/* webpackChunkName: "quotation" */ '@/views/my-store/quotation')
const trade = () => import(/* webpackChunkName: "trade" */ '@/views/my-store/trade')

export default {
  path: '/my-store',
  name: '/my-store',
  component: RouteView,
  meta: { title: '我的店铺', keepAlive: false, icon: 'iconfont zhanghuliebiao' },
  children: [
    {
      path: '/my-store/home',
      name: '/my-store/home',
      component: home,
      meta: { title: '店铺首页', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
    {
      path: '/my-store/setting',
      name: '/my-store/setting',
      component: setting,
      meta: { title: '店铺设置', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
    {
      path: '/my-store/quotation',
      name: '/my-store/quotation',
      component: quotation,
      meta: { title: '报价列表', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
    {
      path: '/my-store/trade',
      name: '/my-store/trade',
      component: trade,
      meta: { title: '挂牌列表', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
    {
      path: '/my-store/order',
      name: '/my-store/order',
      component: order,
      meta: { title: '订单列表', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
    {
      path: '/my-store/warehouse',
      name: '/my-store/warehouse',
      component: warehouse,
      meta: { title: '仓库维护', keepAlive: false, icon: 'el-icon-star-on', action: [] }
    },
  ]
}
